// extracted by mini-css-extract-plugin
module.exports =  {"add-item":"add-item-EBrwa","input":"input-iITch","actions":"actions-a9mxc","add":"add-IsY_6","cancel":"cancel-gSD5_","icon":"icon-lYjLQ"};